import { Row } from 'antd';
import React from 'react';

import { IInvoicePaymentProps } from './types';

const InvoiceConclusion: React.FC<IInvoicePaymentProps> = ({ invoice }) => (
  <>
    <Row justify='end' align='middle' className='gx-mx-0'>
      <div className='conclusion-price-container'>
        <span className='gx-font-weight-medium'>Total:</span>
        <span className='invoice-price-number gx-text-primary'>${invoice?.total}</span>
      </div>
    </Row>
    <Row justify='end' align='middle' className='gx-mx-0'>
      <div className='conclusion-price-container'>
        <span className='gx-font-weight-medium'>Paid:</span>
        <span className='invoice-price-number gx-text-primary'>${invoice?.paid}</span>
      </div>
    </Row>
    <Row justify='end' align='middle' className='gx-mx-0'>
      <div className='conclusion-price-container'>
        <span className='gx-font-weight-medium'>Balance:</span>
        <span className='invoice-price-number gx-text-pending'>${invoice?.balance}</span>
      </div>
    </Row>
  </>
);

export default React.memo(InvoiceConclusion);
